// services/medicineRequestApiService.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_QWIK_MEDIC_API_URL;
const TOKEN = process.env.REACT_APP_QWIK_MEDIC_TOKEN;

const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Authorization': `${TOKEN}`,
    'Content-Type': 'application/json',
  },
});

export const medicineRequestApiService = {
  // Get all medicine requests
  getAllMedicineRequests: async () => {
    try {
      const response = await axiosInstance.get('medRequest/');
      return response.data.reverse(); // Show latest first
    } catch (error) {
      console.error('Error fetching medicine requests:', error);
      throw error;
    }
  },

  // Get single request
  getMedicineRequest: async (id) => {
    try {
      const response = await axiosInstance.get(`medRequest/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching medicine request:', error);
      throw error;
    }
  },

  // Update request status
  updateMedicineRequest: async (id, requestData) => {
    try {
      const response = await axiosInstance.patch(`medRequest/${id}`, requestData);
      return response.data;
    } catch (error) {
      console.error('Error updating medicine request:', error);
      throw error;
    }
  },

  // Delete request
  deleteMedicineRequest: async (id) => {
    try {
      await axiosInstance.delete(`medRequest/${id}`);
      return true;
    } catch (error) {
      console.error('Error deleting medicine request:', error);
      throw error;
    }
  },
};